import React from "react";
import FormIntro from "../../components/Home/FormIntro";
import FormTerms from "../../components/Home/FormTerms"; // Import FormTerms

const HomePage = () => {
  return (
    <div>
      {/* Form Intro */}
      <FormIntro />
      
      {/* Terms & Conditions */}
      <FormTerms />
    </div>
  );
};

export default HomePage;

